import MorningAcademyPage from "./MorningAcademyPage";

export default function MorningAcademyEinKarem() {
  return (
    <MorningAcademyPage
      testIdPrefix="morning-ein-karem"
      locationName="עין כרם"
      titleLine1="אקדמיית הבוקר של"
      titleLine2Red="עין כרם"
      days="שני ורביעי"
      hours="06:30 – 07:30"
      audience={[
        "תלמידי בית הספר החקלאי עין כרם",
        "שחקני הפועל מטה יהודה ממחלקת הנוער",
        "שחקנים וספורטאים המעוניינים בהעשרה מקצועית",
      ]}
      whatsappGroupUrl="https://chat.whatsapp.com/LE5XYdPxxCf9j14ypv5ffu"
    />
  );
}
